import React, { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { fmt3, MAX_REMARKS } from './reverseHelpers';

/**
 * Collapsible grid of unallocated payments with an editable Remarks column.
 * Rows are `{ ...apiRow, remarks, originalRemarks }`; a row is dirty when the two differ.
 * @param {{
 *   rows: object[], loading: boolean, updating: boolean, disabled: boolean,
 *   onRemarksChange: (unallocatedId: string, remarks: string) => void, onUpdate: () => void
 * }} props
 */
const UnallocatedPaymentsGrid = ({ rows, loading, updating, disabled, onRemarksChange, onUpdate }) => {
    const [open, setOpen] = useState(true);
    const th = { whiteSpace: 'nowrap' };
    const hasDirty = rows.some((r) => r.remarks !== r.originalRemarks);

    return (
        <div className="cost-center-section mt-3 mb-4">
            <div className="d-flex slide-header justify-content-between" style={{ cursor: 'pointer' }} onClick={() => setOpen((o) => !o)}>
                <div className="param-label pt-1">Unallocated Payments {rows.length > 0 && `(${rows.length})`}</div>
                <div className="pt-1 pe-2">{open ? '▲' : '▼'}</div>
            </div>
            {open && (
                <>
                    <div className="table-container" style={{ overflowX: 'auto', maxHeight: 300, overflowY: 'auto' }}>
                        <table className="table table-bordered mb-0">
                            <thead className="dynoTable">
                                <tr>
                                    <th style={th}>Record Id</th>
                                    <th style={th}>Lease No</th>
                                    <th style={th}>Receipt Type</th>
                                    <th style={th}>Property</th>
                                    <th style={th}>Unit</th>
                                    <th style={th}>Tenant No</th>
                                    <th style={th}>Tenant</th>
                                    <th style={th}>Receipt No</th>
                                    <th style={th}>Type</th>
                                    <th style={{ ...th, textAlign: 'right' }}>Amount</th>
                                    <th style={th}>Date</th>
                                    <th style={th}>Property No</th>
                                    <th style={th}>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr><td colSpan={13} className="text-center p-3"><ClipLoader size={22} color="#6c5ce7" /></td></tr>
                                )}
                                {!loading && rows.length === 0 && (
                                    <tr><td colSpan={13} className="text-center text-muted p-3">No unallocated payments.</td></tr>
                                )}
                                {!loading && rows.map((row) => (
                                    <tr key={row.unallocatedId} className={row.remarks !== row.originalRemarks ? 'table-warning' : ''}>
                                        <td>{row.unallocatedId}</td>
                                        <td>{row.leaseNo}</td>
                                        <td>{row.receiptType}</td>
                                        <td>{row.propertyName}</td>
                                        <td>{row.unitNo}</td>
                                        <td>{row.customerNo}</td>
                                        <td>{row.customerName}</td>
                                        <td>{row.receiptNo}</td>
                                        <td>{row.type}</td>
                                        <td style={{ textAlign: 'right' }}>{fmt3(row.unallocatedAmount)}</td>
                                        <td style={th}>{row.paymentDate}</td>
                                        <td>{row.propertyId}</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="p-1 form-control"
                                                style={{ minWidth: 220 }}
                                                maxLength={MAX_REMARKS}
                                                disabled={disabled}
                                                value={row.remarks}
                                                onChange={(e) => onRemarksChange(row.unallocatedId, e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="border-box2 p-3">
                        <button type="button" className="mainbtn" disabled={disabled || updating || !hasDirty} onClick={onUpdate}>
                            {updating ? <ClipLoader color="#ffffff" size={20} /> : 'Update Remarks'}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default UnallocatedPaymentsGrid;
